import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import BaseTableView from 'properties/BaseTableView.js'
import { View } from 'backbone';
import Template from 'properties/main/list-item.ejs';
import eventBus         from 'EventBus.js';
import util from 'util/Util.js';
import PredefinedListsModal from 'common-views/PredefinedListsModalView.js';
import PredefinedListsService from 'PredefinedListsService';
import RestService from 'RestService';
import NotificationService  from 'NotificationService';
import listService          from 'ListService.js';

class MainListItemView extends BaseTableView {

    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.config = opts.config || {};

        this.events = {
            "click .itemNew"              : "itemNew",
            "click .itemRemove"           : "itemRemove",
            "click .itemUp"               : "itemUp",
            "click .itemDown"             : "itemDown",
            "click #allowMultiple"        : "updateCheckAttributes",
            "click .itemList" : "itemPredefinedList"
        };

        this.model.set({
            colModel: [
                {
                    name: 'caption',
                    index: 'caption',
                    width: 150,
                    editable: true
                },
                {
                    name: 'value',
                    index: 'value',
                    width: 150,
                    editable: true
                }
            ],
            colNames: ['Caption', 'Value']
        },{silent:true});

        if (this.model.get('gridData').length === 0) {
            this.loadDataFromProperty();
        }


        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    loadDataFromProperty() {
        const prop = this.model.get('Property');
        let captions = _.find(prop, function(obj) { return obj._id === 'captions' }) ;
        let values = _.find(prop, function(obj) { return obj._id === 'values' }) ;

        if (!captions.Item) { captions.Item = []; }
        if (!values.Item) { values.Item = []; }

        let gridData = [];


        if (Array.isArray(captions.Item)) {
            for (let i = 0; i < captions.Item.length; i++) {

                let newRow = {
                    'caption': captions.Item[i]._value,
                    'value': values.Item[i]._value
                };

                gridData.push(newRow);
            }
        } else {
            let newRow = {
                'caption': captions.Item._value,
                'value': values.Item._value
            };

            gridData.push(newRow);

            // enforce array type
            const newItem = {_value: captions.Item._value};
            captions.Item = [newItem];

            const newValueItem = {_value: values.Item._value};
            values.Item = [newValueItem];
        }

        this.model.set('gridData', gridData, {silent: true});
    }

    itemNew(){
        this.model.set('newRowAdded', true, constants.MODEL_SILENT);
        util.saveGridScrollPos(this.model);
            let gridData = this.model.get('gridData');
            let newRow = {
                'caption':'Item ' + (gridData.length+1) ,
                'value': (gridData.length+1)
            };
            $(constants.PROP_MAIN_TABLE).addRowData((gridData.length), newRow);
    
            gridData.push(newRow);
    
            let captions = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'captions' });
            let values = _.find(this.model.attributes.Property, function(obj) { return obj._id === 'values' });

            captions.Item.push({ _value: 'Item ' + (gridData.length) } );
            values.Item.push({ _value: (gridData.length) } );
    
            this.model.set('gridData', gridData,{silent:true});
            eventBus.trigger('addItemOnList');
            eventBus.trigger(constants.EV_REFRESH_REMOTE_DATA_FILTER);
    }

    afterEditCell(rowId, cellName, value, iRow, iCol) {
        let self=this;
        $("#" + iRow + "_" + cellName).bind('blur', function () {
            $(self.gridEl).saveCell(iRow, iCol);
        });
    }


    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( 'multiSelection', propVal );
    }

    fillGrid(elements){
        let gridData=this.model.get('gridData');
        gridData=[];
        Object.keys(elements).forEach((key)=>{
            let newRow = {
                'caption':elements[key] ,
                'value': key
            };
            gridData.push(newRow);
        });
        this.model.set('gridData', gridData);
    }

    fillGridFromCustomList(elements){
        let gridData=this.model.get('gridData');
        gridData=[];
        elements.forEach((list)=>{
            let newRow = {
                'caption':list["@caption"] ,
                'value': list["@value"]
            };
            gridData.push(newRow);
        });
        this.model.set('gridData', gridData);
    }

      itemPredefinedList(event){
        let predModal = new PredefinedListsModal({model: this.model});
        predModal.render().then((selected)=>{
          let items;
          $(constants.PROP_MAIN_TABLE).clearGridData();
          switch (selected){
            case 'countries':
              items=PredefinedListsService.getCountries();
              this.fillGrid(items);
              break;
            case 'states':
              items=PredefinedListsService.getUSStates();
              this.fillGrid(items);
              break;
            case 'provinces':
              items=PredefinedListsService.getCanadianProvinces();
              this.fillGrid(items);
              break;
            default:
              this.processCustomListItems(selected)
          }
        });
      }

      processCustomListItems(selected){
        RestService.getCustomList(selected).then((customLists)=>{
          let customListsArray=customLists instanceof Array ? customLists : [customLists];
          this.fillGridFromCustomList(customListsArray);
        }).catch((err=>{
          console.log('Error retrieving custom list items ',err);
          NotificationService.error('Error retrieving custom list items '+err.MESSAGE);
        }));
      }

    render() {
        super.render();
        let bMultiSelection = util.isTrue(this.model.get('multiSelection'));
        $(`input[name='allowMultiple']`).prop('checked', bMultiSelection );
    }

}

export default MainListItemView;
